export const temperatureInitial = {
    typeName: '',
    isActive: false,
}

export const addonsInitial = {
    addonName: '',
    price: 0,
    isAvailable: false,
    isOutOfStock: false,
}

export const categoryInitial = {
    categoryName: '',
    description: '',
    isActive: false,
}

export const sizeInitial = {
    size: '',
    isActive: false,
}